import { render, staticRenderFns } from "./upload-new.vue?vue&type=template&id=75e26e7f&"
import script from "./upload-new.vue?vue&type=script&lang=js&"
export * from "./upload-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports